
import LayoutContent from '../../components/layouts/content2';
import React, {useState} from 'react';

import {useTranslation} from 'react-i18next';

import SpecialsScreen from './specials';

import CategoriesScreen from './categories';

import Cocktails from './cocktails';
import EventsScreen from './events';
import Alcoholic from './alcoholic';

function Index({setShowHappy}) { 

    
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);

    const eventImages = [
        require('./assets/event1.png'),
       
    ];

    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent  goCategories={setshowCategories} showCocktails={ setShowCocktails} showEvents={ setShowEvents} showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy}>
                <div style={{padding: '0 20px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                    <div style={{width: '100%', marginBottom: 2, position: 'relative'}}>
                        {/* <img
                            src={eventImages[0]}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{
                                width: '90%',
                                height: 800,
                                objectFit: 'cover',
                                borderRadius: 25,
                                pointerEvents: 'none',
                                
                            }}
                        /> */}

                         <img
                            src={require('./assets/events.jpg')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{
                                width: '90%',
                                height: 580,
                                objectFit: 'contain',
                                borderRadius: 25,
                                pointerEvents: 'none',
                                
                            }}
                        />

                         <img
                            src={require('./assets/EVENTOS.jpg')}
                            onContextMenu={(e) => e.preventDefault()}
                            style={{
                                width: '90%',
                                height: 190,
                                objectFit: 'contain',
                                borderRadius: 25,
                                pointerEvents: 'none',
                                marginTop: 15,
                                
                            }}
                        />
                    </div>

                </div>

                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
            </LayoutContent>
        </div>
    );
}
export default Index;